import $ from 'jquery';

const $form = $('#sidebar-form');
const $prices = $form.find('.price-change');
const $minMax = $form.find('input.min-max');

$prices.on('change', () => $minMax.val(''));
$minMax.on('keyup change', () => $prices.prop('checked', false));

let $submitWait = null;
$('input[type=checkbox], input[type=radio]').on('change', () => {
    if ($submitWait != null) clearTimeout($submitWait);
    $submitWait = setTimeout(() => $form.submit(), 500);
});
